export const E2E_QUERY_KEY = '_e2eDB'
